import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { api } from "../../helpers/utils";

export default function UserDetailsScreen() {
  const { mobileNumber } = useParams();
  const [mobile, setMobile] = useState('');
    const [username, setUsername] = useState('');
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [issueText, setIssueText] = useState('');
  const [updatingIssue, setUpdatingIssue] = useState(false);

  useEffect(() => {
    if (mobileNumber && mobileNumber.trim()) {
      setMobile(mobileNumber.trim());
    }
  }, [mobileNumber]);

  const fetchUserDetails = async () => {
    // if (!mobile || !mobile.trim()) return;

    try {
      setLoading(true);
      const res = await api.post('/get-user-details-admin', {
        mobileNumber: mobile.trim(),
        username: username.trim(),
      });
      setLoading(false);

      if (res.data.status === 100) {
        setUserDetails(res.data.userDetails);
        setIssueText(res.data.userDetails.verificationIssue || '');
      } else {
        alert('User not found');
        setUserDetails(null);
      }
    } catch (e) {
      console.error(e);
      alert('Error fetching user details');
      setLoading(false);
    }
  };

  const handleVerifyToggle = async () => {
    if (!userDetails?._id) return;

    try {
      setVerifying(true);
      const res = await api.post('/verify-user', {
        userId: userDetails._id,
        isVerified: !userDetails.isVerified,
      });
      setVerifying(false);

      if (res.data.status === 100) {
        alert('User verification updated.');
        fetchUserDetails();
      } else {
        alert('Failed to update verification.');
      }
    } catch (e) {
      console.error(e);
      alert('Error updating verification');
      setVerifying(false);
    }
  };

  const handleUpdateIssue = async () => {
    if (!userDetails?._id || !issueText.trim()) {
      alert('Please enter an issue reason.');
      return;
    }

    try {
      setUpdatingIssue(true);
      const res = await api.post('/verification-issue', {
        userId: userDetails._id,
        verificationIssue: issueText.trim(),
      });
      setUpdatingIssue(false);

      if (res.data.status === 100) {
        alert('Issue updated successfully.');
        fetchUserDetails();
      } else {
        alert('Failed to update issue.');
      }
    } catch (e) {
      console.error(e);
      alert('Error updating issue');
      setUpdatingIssue(false);
    }
  };

  const [newUsername, setNewUsername] = useState('');
  const [updatingUsername, setUpdatingUsername] = useState(false);

  const hasVerificationIssue = Boolean(userDetails?.verificationIssue || issueText.trim());


  const handleUpdateUsername = async () => {
    if (!userDetails?._id || !newUsername.trim()) {
      alert('Please enter a valid username.');
      return;
    }
  
    try {
      setUpdatingUsername(true);
      const res = await api.post('/update-username', {
        mobileNumber: userDetails.mobileNumber,
        userName: newUsername.trim()
      });
      setUpdatingUsername(false);
  
      if (res.data.status === 100) {
        alert('Username updated successfully.');
        fetchUserDetails();
      } else {
        alert('Failed to update username.');
      }
    } catch (e) {
      console.error(e);
      alert('Error updating username');
      setUpdatingUsername(false);
    }
  };
  
  return (
    <Page>
      <Card>
        <Heading>Find User</Heading>

        <Field>
          <Label>Mobile Number</Label>
          <Input type="text" placeholder="Enter mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} />
        </Field>

        <Field>
          <Label>Username</Label>
          <Input type="text" placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </Field>

        <PrimaryButton onClick={fetchUserDetails} disabled={loading}>
          {loading ? "Loading..." : "Get User Details"}
        </PrimaryButton>

        {userDetails && (
          <DetailsCard>
            <SummaryGrid>
              <SummaryCard>
                <SummaryLabel>Verification</SummaryLabel>
                <SummaryValue>{userDetails.isVerified ? "Verified" : "Not Verified"}</SummaryValue>
              </SummaryCard>
              <SummaryCard>
                <SummaryLabel>Payment</SummaryLabel>
                <SummaryValue>{userDetails.isPaymentDone ? "Done" : "Not Done"}</SummaryValue>
              </SummaryCard>
              <SummaryCard hasIssue={hasVerificationIssue}>
                <SummaryLabel>Issue</SummaryLabel>
                <SummaryValue>{hasVerificationIssue ? "Needs review" : "No issue"}</SummaryValue>
              </SummaryCard>
            </SummaryGrid>

            {hasVerificationIssue && (
              <IssueBanner>
                <strong>Verification issue</strong>
                <span>{userDetails.verificationIssue || issueText}</span>
              </IssueBanner>
            )}

            <SectionHeading>User Info</SectionHeading>
            <DetailGrid>
              <DetailItem>
                <DetailLabel>ID</DetailLabel>
                <DetailValue>{userDetails._id}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Username</DetailLabel>
                <DetailValue>{userDetails.userName}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>u_username</DetailLabel>
                <DetailValue>{userDetails.u_username}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Phone</DetailLabel>
                <DetailLink href={`tel:${userDetails.mobileNumber}`}>{userDetails.mobileNumber}</DetailLink>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Gender</DetailLabel>
                <DetailValue>{userDetails.gender}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Age</DetailLabel>
                <DetailValue>{userDetails.age}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Bio</DetailLabel>
                <DetailValue>{userDetails.bio}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Det Coins</DetailLabel>
                <DetailValue>{userDetails.detCoins}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Status</DetailLabel>
                <StatusBadge>
                  {userDetails.isVerified ? "Verified" : "Not Verified"}
                </StatusBadge>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Payment</DetailLabel>
                <StatusBadge>
                  {userDetails.isPaymentDone ? "Done" : "Not Done"}
                </StatusBadge>
              </DetailItem>
              <DetailItem>
                <DetailLabel>Created</DetailLabel>
                <DetailValue>{new Date(userDetails.timestamp).toLocaleString()}</DetailValue>
              </DetailItem>
              {userDetails.latLong && (
                <DetailItem>
                  <DetailLabel>Location</DetailLabel>
                  <DetailValue>
                    Lat {userDetails.latLong.latitude}, Long {userDetails.latLong.longitude}
                  </DetailValue>
                </DetailItem>
              )}
            </DetailGrid>

            {userDetails.verificationDetails && (
              <SectionCard>
                <SectionHeading>Verification Details</SectionHeading>
                <DetailGrid>
                  <DetailItem>
                    <DetailLabel>Name</DetailLabel>
                    <DetailValue>{userDetails.verificationDetails.name}</DetailValue>
                  </DetailItem>
                  <DetailItem>
                    <DetailLabel>Email</DetailLabel>
                    <DetailValue>{userDetails.verificationDetails.email}</DetailValue>
                  </DetailItem>
                  <DetailItem>
                    <DetailLabel>DOB</DetailLabel>
                    <DetailValue>{userDetails.verificationDetails.dob}</DetailValue>
                  </DetailItem>
                  <DetailItem>
                    <DetailLabel>LinkedIn</DetailLabel>
                    <DetailLink href={userDetails.verificationDetails.linkedin} target="_blank" rel="noopener noreferrer">
                      {userDetails.verificationDetails.linkedin}
                    </DetailLink>
                  </DetailItem>
                  <DetailItem>
                    <DetailLabel>ID Proof</DetailLabel>
                    <DetailLink href={userDetails.verificationDetails.idProofUrl} target="_blank" rel="noopener noreferrer">
                      View
                    </DetailLink>
                  </DetailItem>
                </DetailGrid>
              </SectionCard>
            )}

            <Field>
              <Label>Verification Issue</Label>
              <TextArea
                rows={3}
                value={issueText}
                onChange={(e) => setIssueText(e.target.value)}
                placeholder="Enter issue/reason (if any)"
              />
              <WarningButton onClick={handleUpdateIssue} disabled={updatingIssue}>
                {updatingIssue ? "Updating..." : "Update Issue"}
              </WarningButton>
            </Field>

            <Field>
              <Label>Update Username</Label>
              <Input
                type="text"
                value={newUsername}
                onChange={(e) => setNewUsername(e.target.value)}
                placeholder="Enter new username"
              />
              <SecondaryButton onClick={handleUpdateUsername} disabled={updatingUsername}>
                {updatingUsername ? "Updating..." : "Update Username"}
              </SecondaryButton>
            </Field>

            <VerifyButton danger={userDetails.isVerified} onClick={handleVerifyToggle} disabled={verifying}>
              {verifying ? "Updating..." : userDetails.isVerified ? "Remove Verification" : "Verify User"}
            </VerifyButton>
          </DetailsCard>
        )}
      </Card>
    </Page>
  );
}

const Page = styled.div`
  background: #000000;
  min-height: 100vh;
  padding: 50px 20px 100px;
  display: flex;
  justify-content: center;
  color: #ffffff;
`;

const Card = styled.div`
  width: min(920px, 100%);
  background: #050505;
  border: 1px solid #303030;
  padding: 40px 32px 120px;
`;

const Heading = styled.h2`
  text-align: center;
  font-size: 34px;
  margin-bottom: 30px;
  color: #ffffff;

  @media (max-width: 560px) {
    font-size: 26px;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
`;

const Label = styled.label`
  font-size: 14px;
  color: #bdbdbd;
`;

const Input = styled.input`
  width: 100%;
  padding: 14px;
  border: 1px solid #303030;
  background-color: #000000;
  color: #ffffff;
  font-size: 15px;
  outline: none;

  &:focus {
    border-color: #ffffff;
  }
`;

const PrimaryButton = styled.button`
  margin-top: 20px;
  width: 100%;
  padding: 16px;
  border: 1px solid #ffffff;
  background: #ffffff;
  color: #000000;
  font-weight: 800;
  cursor: pointer;

  &:hover {
    background: #000000;
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const DetailsCard = styled.div`
  margin-top: 40px;
  padding: 24px;
  background: #000000;
  border: 1px solid #303030;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

const SummaryCard = styled.div`
  border: 1px solid ${({ hasIssue }) => (hasIssue ? "#a16207" : "#303030")};
  background: ${({ hasIssue }) => (hasIssue ? "rgba(161, 98, 7, 0.14)" : "#050505")};
  padding: 16px;
`;

const SummaryLabel = styled.span`
  display: block;
  color: #bdbdbd;
  font-size: 12px;
  text-transform: uppercase;
`;

const SummaryValue = styled.strong`
  display: block;
  margin-top: 8px;
  color: #ffffff;
  font-size: 18px;
`;

const IssueBanner = styled.div`
  border: 1px solid #a16207;
  background: rgba(161, 98, 7, 0.14);
  padding: 16px;

  strong,
  span {
    display: block;
  }

  strong {
    color: #fde68a;
    margin-bottom: 6px;
  }

  span {
    color: #ffffff;
    line-height: 1.5;
  }
`;

const SectionHeading = styled.h3`
  margin: 0;
  font-size: 18px;
  color: #ffffff;
`;

const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const DetailLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0;
  color: #8c8c8c;
`;

const DetailValue = styled.span`
  font-size: 15px;
  color: #f1f1f1;
  word-break: break-word;
`;

const StatusBadge = styled.span`
  width: fit-content;
  border: 1px solid #303030;
  background: #050505;
  color: #d4d4d4;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 800;
`;

const DetailLink = styled.a`
  color: #ffffff;
  font-size: 15px;
  word-break: break-word;
  text-decoration: underline;
`;

const SectionCard = styled.div`
  padding: 18px;
  background: #050505;
  border: 1px solid #303030;
`;

const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid #303030;
  background: #000000;
  color: #ffffff;
  padding: 14px;
  min-height: 90px;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: #ffffff;
  }
`;

const SecondaryButton = styled.button`
  padding: 14px;
  border: 1px solid #ffffff;
  background: #000000;
  color: #ffffff;
  font-weight: 800;
  cursor: pointer;

  &:hover {
    background: #ffffff;
    color: #000000;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const WarningButton = styled(SecondaryButton)`
  border-color: #a16207;
  background: rgba(161, 98, 7, 0.12);
  color: #ffffff;

  &:hover {
    background: #a16207;
    color: #ffffff;
  }
`;

const VerifyButton = styled.button`
  margin-top: 10px;
  padding: 15px;
  border: 1px solid #ffffff;
  color: ${({ danger }) => (danger ? "#ffffff" : "#000000")};
  font-weight: 800;
  cursor: pointer;
  background: ${({ danger }) => (danger ? "#000000" : "#ffffff")};

  &:hover {
    background: ${({ danger }) => (danger ? "#ffffff" : "#000000")};
    color: ${({ danger }) => (danger ? "#000000" : "#ffffff")};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
